import React from 'react'
import { Button } from "@/components/ui/button";
import { IResExperiences } from '@/lib/interfaces';
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

interface IWorkDetailsSection {
  experiences: IResExperiences[],
  setExperiences: (workExperiences: IResExperiences[]) => void
}

function WorkSection({ setExperiences, experiences }: IWorkDetailsSection) {
  const addExperience = () => setExperiences([...experiences, { company: "", role: "", fromDate: new Date(), toDate: new Date(), responsibilities: "" }]);
  const removeExperience = (index: number) => setExperiences(experiences.filter((_, i) => i !== index));
  const updateExperience = (index: number, field: string, value: any) => {
    const updated = [...experiences];
    (updated[index] as any)[field] = value;
    setExperiences(updated);
  };
  
  return (
    <section className="space-y-4 p-3 bg-white 
      border-2 border-gray-200 rounded-xl">
    <div className="flex justify-between items-center">
      <h2 className="text-xl text-indigo-600 font-medium">
          Work Experience
      </h2>
      <Button variant="outline" size="sm" onClick={addExperience} className="ml-4"><Plus className="w-4 h-4 mr-1" /> Add Job</Button>
    </div>
    
    {experiences.map((exp, index) => (
      <Card key={index} className="relative group">
        <Button variant="ghost" size="icon" className="absolute top-2 right-2 text-destructive opacity-0 group-hover:opacity-100 transition-opacity" onClick={() => removeExperience(index)}><Trash2 size={16} /></Button>
        <CardContent className="pt-6 grid gap-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <Label htmlFor="compName" className='text-indigo-600 ml-3'>Company Name</Label>
              <Input placeholder="Company Name" id="compName" value={exp.company} onChange={(e) => updateExperience(index, "company", e.target.value)} />
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="role" className='text-indigo-600 ml-3'>Job Role</Label>
              <Input placeholder="Job Role" id="role" value={exp.role} onChange={(e) => updateExperience(index, "role", e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* <DatePicker value={exp.fromDate} onChange={(d) => updateExperience(index, "fromDate", d)} /> */}
            <div className="flex flex-col gap-2">
              <Label htmlFor="fromDate" className='text-indigo-600 ml-3'>From Date</Label>
              <Input type="date" id="fromDate" 
                value={exp.fromDate instanceof Date ? exp.fromDate.toISOString().split('T')[0] : exp.fromDate} 
                onChange={(d) => {
                  updateExperience(index, "fromDate", d.currentTarget.value)
                  }} />
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="toDate" className='text-indigo-600 ml-3'>To Date</Label>
              <Input type="date" id="toDate" 
                value={exp.toDate instanceof Date ? exp.toDate.toISOString().split('T')[0] : exp.toDate} 
                onChange={(d) => updateExperience(index, "toDate", d.currentTarget.value)} />
            </div>
            {/* <DatePicker value={exp.toDate} onChange={(d) => updateExperience(index, "toDate", d)} /> */}
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="responsibilities" className='text-indigo-600 ml-3'>Responsibilities (Multiline)</Label>
            <Textarea placeholder="Responsibilities (Multiline)" id="responsibilities" value={exp.responsibilities} onChange={(e) => updateExperience(index, "responsibilities", e.target.value)} />
          </div>
        </CardContent>
      </Card>
    ))}
  </section>
  )
}

export default WorkSection;